import { Localized } from "@fluent/react"
import { FormControl, InputLabel, MenuItem, Select } from "@mui/material"

export type QMSLanguage = "PL" | "EN"

interface QMSLanguageSelectProps {
    value: QMSLanguage
    onChange: (value: QMSLanguage) => void
}

export const QMSLanguageSelect = ({ value, onChange }: QMSLanguageSelectProps) => {
    return (
        <FormControl fullWidth>
            <InputLabel id="qms-document-language-label">
                <Localized id="document-language">
                    <span>_Język dokumentu</span>
                </Localized>
            </InputLabel>

            <Select
                labelId="qms-document-language-label"
                id="qms-document-language"
                value={value}
                onChange={(event) => onChange(event.target.value as QMSLanguage)}
                label={
                    <Localized id="document-language">
                        <span>_Język dokumentu</span>
                    </Localized>
                }
            >
                <MenuItem value="PL">
                    <Localized id="polish">
                        <span>_Polski</span>
                    </Localized>
                </MenuItem>

                <MenuItem value="EN">
                    <Localized id="english">
                        <span>_Angielski</span>
                    </Localized>
                </MenuItem>
            </Select>
        </FormControl>
    )
}
